module.exports = __webpack_public_path__ + "static/IMG-2413-0e289988938f86785689f57159d5b887.jpg";